<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader
            class="bg-gradient-warning text-white"
            style="border-top-left-radius: 1rem; border-top-right-radius: 1rem"
          >
            <span class="font-weight-bold h6">
              <CIcon :name="icon" size="lg" /> {{ caption }}
            </span>
            <div class="card-header-actions">
              <CButton
                class="ml-2"
                size="sm"
                color="light"
                shape="pill"
                variant="outline"
                v-c-tooltip.hover.click="'Reload'"
                @click="onReload"
              >
                <span class="font-weight-bold">
                  <CIcon name="cil-reload" />
                </span>
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <CTabs add-tab-classes="mt-1">
              <CTab v-for="(objs, index) in item" :key="activityTabKey(objs, index)">
                <template slot="title">
                  <CIcon name="cil-calculator" /> {{ objs.title }}
                </template>
                <CCardBody>
                  <Timeline v-if="objs.historys.length > 0 && index === 0" :objs="objs" />
                  <CRow>
                    <CCol>
                      <CDataTable
                        :table-filter="{ label: '' }"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        :fields="objs.fields"
                        :items="objs.historys"
                        :items-per-page="small ? 50 : 20"
                        :dark="dark"
                        pagination
                      >
                        <template #index="{ item, index }">
                          <td>{{ index + 1 }}</td>
                        </template>

                        <template #status="{ item, index }">
                          <td>
                            <span
                              class="font-weight-bold"
                              :class="isColor(item.status.at(-1).state)"
                            >
                              {{ item.status.at(-1).state.title.filter(objs => objs.key === lang).at(-1).value }}
                            </span>
                            {{ onCheckState(item, index) }}
                            <br>
                            <span
                              class="font-weight-bold"
                              :class="isColor(item.status.at(-1).state)"
                            >
                              {{ $t('LatestTime') }} :
                            </span>
                            {{ elapsedTime(item.status.at(-1).timeStamp) }}
                          </td>
                        </template>

                        <template #action="{ item, index }">
                          <td style="width: 140px">
                            <CRow>
                              <CCol class="text-center">
                                <CButton
                                  class="mr-1"
                                  size="sm"
                                  color="info"
                                  shape="pill"
                                  variant="outline"
                                  v-c-tooltip.hover.click="'Open'"
                                  @click="onIDP(item, index)"
                                >
                                  <CIcon name="cil-clipboard" />
                                </CButton>

                                <CButton
                                  v-if="objs.type === 0"
                                  class="mr-1"
                                  size="sm"
                                  color="danger"
                                  shape="pill"
                                  variant="outline"
                                  v-c-tooltip.hover.click="'Clear All'"
                                  @click="obRestore(item, index)"
                                >
                                  <CIcon name="cil-loop-circular" />
                                </CButton>
                              </CCol>
                            </CRow>
                          </td>
                        </template>
                      </CDataTable>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import History from '@/projects/views/E-Performances/Estimate/components/Historys'
import EDCompetency from '@/projects/views/E-Performances/Dashboard/users/components/EDCompetency.vue'
import Timeline from '@/projects/views/E-Performances/IndividualDevelopmentPlan/component/Timeline.vue'
import TimelineDanger from '@/projects/views/E-Performances/Dashboard/users/timeline_danger.vue'

export default {
  name: 'Activitys',
  components: { TimelineDanger, Timeline, EDCompetency, History, Multiselect },

  props: {
    caption: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'cil-layers'
    },
    disable: {
      type: Boolean,
      default: false
    },
    item: {
      type: Array,
      default() {
        return []
      }
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      lang: 'setting/lang',
      isAction: 'dialog/isCode'
    })
  },

  watch: {

    isAction(value) {
      if (value === 'restore-delete') {
        this.$store.dispatch('idp/initByAccount', {})
        this.$store.commit('dialog/isCode', null)

        setTimeout(() => {
          this.$emit('reload', {})
        }, 2000)
      }
    }
  },

  created() {
    this.onInit()
  },

  methods: {
    elapsedTime(dateTime) {
      const now = moment()
      const past = moment(dateTime)
      const duration = moment.duration(now.diff(past))
      const minutes = duration.asMinutes()
      const hours = duration.asHours()
      const days = duration.asDays()

      if (minutes < 1) {
        return this.lang === 'th' ? 'เมื่อสักครู่นี้' : 'Just now'
      } else if (minutes < 60) {
        return `${Math.floor(minutes)} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`
      } else if (hours < 24) {
        const h = Math.floor(hours)
        const m = Math.floor(minutes % 60)
        return `${h} ${this.lang === 'th' ? 'ชั่วโมง' : 'h'} ${m} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`
      } else {
        return past.format('DD/MM/YYYY HH:mm')
      }
    },

    onInit() {
      // Initialize component
    },

    activityTabKey(item, index) {
      return `${item && (item.id || item._id || item.type || item.title) ? (item.id || item._id || item.type || item.title) : 'tab'}-${index}`;
    },

    onReload() {
      this.$emit('reload', {})
    },

    obRestore(item, index) {
      const dialog = {
        title: '',
        message: this.$t('idp.dialog.clear'),
        code: '00000',
        number: '0',
        status: true,
        actions: [
          { label: 'CONFIRM', code: 'restore-delete', icon: 'cil-save' }
        ]
      }
      this.$store.commit('dialog/dialog', dialog)
    },

    onIDP(item, index) {
      item.isIDP = true
      this.$emit('info', item)
    },

    isColor(item) {
      const stateMap = {
        '654851dbe41b7f46025977f6': 'text-warning', // save
        '654851ece41b7f46025977fa': 'text-info', // send
        '670f777373effdb76e17954d': '', // unsend
        '6723709ab9a2030e40d1b884': 'text-danger', // Reject
        '67bc20d5ef3c015b73cf6dbc': 'text-warning', // Verification
        '67bc35d9ac0179614e274a67': 'text-warning', // development
        '67bfc7e724e13ba338b58e47': 'text-info', // result in development
        '67bfc7ed24e13ba338b58e4d': 'text-success' // complete
      }

      return stateMap[item._id] || ''
    },

    onCheckState(item, index) {
      const status = item.status.at(-1).state._id
      const stateToPersonMap = {
        '654851a37ab25be71bbeeed6': item.info,
        '654851dbe41b7f46025977f6': item.info,
        '654851ece41b7f46025977fa': item.assessor,
        '6723709ab9a2030e40d1b884': item.info, // Reject
        '67bc20d5ef3c015b73cf6dbc': item.assessor,
        '670f777373effdb76e17954d': item.info,
        '67bc2105ef3c015b73cf6dc2': item.info,
        '67bc2111ef3c015b73cf6dc8': item.info,
        '67bc35d9ac0179614e274a67': item.info, // Development
        '67bfc7e724e13ba338b58e47': item.assessor // Result In Development
      }

      const person = stateToPersonMap[status]
      return person ? ` : ${person}` : ''
    }
  }
}
</script>

<style scoped>
</style>
